export default function setUser(user) {
  localStorage.setItem("authUser", user);
}
